'use client';

import { create } from 'zustand';

interface SupportChatState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useSupportChatStore = create<SupportChatState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

export const useOpenSupportChat = () => useSupportChatStore((s) => s.open);
